import { render, staticRenderFns } from "./TDSHead.vue?vue&type=template&id=9e1b9a02&"
import script from "./TDSHead.vue?vue&type=script&lang=js&"
export * from "./TDSHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports